import type { LanguageCode, TenantId, TenantTerminologyConfig } from './types';

const TERMS_PREFIX = 'terms.';

/**
 * White-label tenant terminoloji katmanı.
 * A müşterisi: terms.customer → "Cari"
 * B müşterisi: terms.customer → "Müşteri"
 */
export class TenantTerminologyService {
  private readonly configs = new Map<TenantId, TenantTerminologyConfig>();

  register(config: TenantTerminologyConfig): void {
    this.configs.set(config.tenantId, config);
  }

  getConfig(tenantId: TenantId): TenantTerminologyConfig | undefined {
    return this.configs.get(tenantId);
  }

  /**
   * Base çeviri metnine tenant override uygular.
   */
  resolve(
    tenantId: TenantId,
    _language: LanguageCode,
    key: string,
    baseValue: string,
  ): string {
    const config = this.configs.get(tenantId);
    if (!config) return baseValue;

    if (config.overrides?.[key]) {
      return config.overrides[key]!;
    }

    if (key.startsWith(TERMS_PREFIX) && config.terminology) {
      const termKey = key.slice(TERMS_PREFIX.length);
      if (config.terminology[termKey]) {
        return config.terminology[termKey]!;
      }
    }

    return baseValue;
  }

  /** Tenant'a özel flat override sözlüğü (i18next bundle merge için) */
  getOverrideDictionary(tenantId: TenantId): Record<string, string> {
    const config = this.configs.get(tenantId);
    if (!config) return {};

    const flat: Record<string, string> = { ...(config.overrides ?? {}) };

    if (config.terminology) {
      for (const [termKey, value] of Object.entries(config.terminology)) {
        flat[`${TERMS_PREFIX}${termKey}`] = value;
      }
    }

    return flat;
  }
}
